// ** Initial State
const initialState = {
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedModule: null
}

const modules = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_MODULES':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_MODULES':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_MODULE':
      return { ...state, selectedModule: action.selectedModule }
    case 'ADD_MODULE':
      return { ...state }
    case 'DELETE_MODULE':
      return { ...state }
    default:
      return { ...state }
  }
}
export default modules
